import { createFileRoute } from "@tanstack/react-router";
import LensPage from "src/components/app/LensPage/LensPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { projectLoader } from "src/lib/ScopedLoaders";
import { getLensesPageData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/lenses/new")({
  // `from` names the lens a new one starts as a copy of.
  validateSearch: (search: Record<string, unknown>): { from?: string } =>
    typeof search.from === "string" ? { from: search.from } : {},
  loader: projectLoader((projectId) => getLensesPageData({ data: projectId })),
  component: NewLensPage,
});

function NewLensPage() {
  const { from } = Route.useSearch();
  return (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => (
        <LensPage from={from} projectId={data?.projectId} initialLenses={data?.initialLenses} />
      )}
    </DeferredLoaderData>
  );
}
